import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = {
        updateUrl: String
    }

    connect() {
        this.$element = window.$ ? window.$(this.element) : null

        if (!this.$element?.sortable) {
            console.error("[panels-sortable] jQuery UI sortable is not available")
            return
        }

        if (this.$element.data("ui-sortable")) {
            this.$element.sortable("destroy")
        }

        this.$element.sortable({
            items: ".drag_list_panel",
            handle: ".card-header",
            tolerance: "pointer",
            helper: "original",
            start: (_event, ui) => {
                console.log("[panels-sortable] start", {
                    elementId: this.element.id,
                    updateUrl: this.updateUrlValue,
                    panelId: ui.item?.attr("id")
                })
            },
            update: (_event, ui) => {
                console.log("[panels-sortable] update", {
                    elementId: this.element.id,
                    updateUrl: this.updateUrlValue,
                    panelId: ui.item?.attr("id")
                })
                this.updateOrder("jquery-ui-update")
            },
            stop: (_event, ui) => {
                console.log("[panels-sortable] stop", {
                    elementId: this.element.id,
                    panelId: ui.item?.attr("id")
                })
            }
        })

        this.$element.disableSelection?.()

        console.log("[panels-sortable] connected", {
            elementId: this.element.id,
            updateUrl: this.updateUrlValue,
            panelCount: this.element.querySelectorAll(".drag_list_panel").length
        })
    }

    updateOrder(source = "manual") {
        const updates = []

        this.element.querySelectorAll(".drag_list_panel").forEach((panel, idx) => {
            panel.querySelectorAll("form.edit_estimate_item").forEach((form) => {
                const itemId = form.id.split("_")[3]
                const input = form.querySelector('input[name="estimate_item[category_order_id]"]')

                if (!itemId || !input) {
                    console.log("[panels-sortable] skipped form", {
                        source,
                        panelId: panel.id,
                        formId: form.id,
                        itemId,
                        hasInput: Boolean(input)
                    })
                    return
                }

                const nextValue = idx.toString()
                if (input.value !== nextValue) {
                    input.value = nextValue
                    updates.push({ id: itemId, category_order_id: idx })
                }
            })
        })

        console.log("[panels-sortable] built payload", {
            source,
            updateUrl: this.updateUrlValue,
            updateCount: updates.length,
            updates
        })

        if (updates.length === 0) return
        if (!this.updateUrlValue) {
            console.error("[panels-sortable] missing updateUrlValue")
            return
        }

        this.$element?.triggerHandler("panelorder:before-save", [updates])

        window.$.ajax({
            url: this.updateUrlValue,
            method: "POST",
            dataType: "json",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-Token": document.querySelector("meta[name='csrf-token']").content
            },
            data: JSON.stringify({ items: updates })
        }).done((response, textStatus, jqXHR) => {
            console.log("[panels-sortable] ajax response", {
                source,
                status: jqXHR.status,
                textStatus,
                response
            })
        }).fail((jqXHR, textStatus, errorThrown) => {
            console.error("[panels-sortable] ajax error", {
                source,
                status: jqXHR.status,
                textStatus,
                errorThrown,
                responseText: jqXHR.responseText
            })
        })
    }

    disconnect() {
        console.log("[panels-sortable] disconnect", {
            elementId: this.element.id
        })

        if (this.$element?.data("ui-sortable")) {
            this.$element.sortable("destroy")
        }

        this.$element = null
    }
}
